export const PricingRequest = ({
  clientCode,
  userID,
  key,
  agencyId,
  flight,
  Journey,
  ClassOfService,
  flightsListRequest
}) => {

  const fareQuoteRequests = [];

  if (flight?.onward || flight?.return) {

    if (flight?.onward) {
      fareQuoteRequests.push(
        mapFlightToAirPricing(
          flight.onward,
          flightsListRequest,
          agencyId,
          ClassOfService,
          "Onward"
        )
      );
    }

    if (flight?.return && flight.return.trip !== 2) {
      fareQuoteRequests.push(
        mapFlightToAirPricing(
          flight.return,
          flightsListRequest,
          agencyId,
          ClassOfService,
          "Return"
        )
      );
    }

  } else {
    fareQuoteRequests.push(
      mapFlightToAirPricing(
        flight,
        flightsListRequest,
        agencyId,
        ClassOfService,
        "Onward"
      )
    );
  }

  return {
    clientCode,
    userID,
    key,
    resultIndex: flight?.resultIndex || "",
    fareQuoteRequests
  };
};


const mapFlightToAirPricing = (
  flight,
  flightsListRequest,
  agencyId,
  ClassOfService,
  Journey
) => {

  const selectedFare =
    flight?.selectedFare ||
    flight?.fares?.[flight?.selectedFareIndex] ||
    flight?.fares?.[0] || null;

  return {
    sCode: flight?.sCode || "",
    supSource: flight?.supSource || "",
    resultIndex: flight?.itemNo || "",   // ✅ MUST be itemNo
    fareUniqueKey: selectedFare?.fareUniqueKey || "",
    journey: Journey
  };
};